import styles from './InitialsAvatar.module.css';

const SIZE_MAP = { sm: 24, md: 32, lg: 40 };
const FONT_MAP = { sm: 10, md: 12, lg: 16 };

const getInitials = (firstName, lastName) => {
  const f = firstName?.trim()?.[0]?.toUpperCase() || '';
  const l = lastName?.trim()?.[0]?.toUpperCase() || '';
  return f + l || '?';
};

const InitialsAvatar = ({
  firstName = '',
  lastName = '',
  color = '#6366f1',
  size = 'md',
}) => {
  const px = SIZE_MAP[size] || SIZE_MAP.md;
  const fontSize = FONT_MAP[size] || FONT_MAP.md;

  return (
    <div
      className={styles.circle}
      style={{
        width: px,
        height: px,
        backgroundColor: color,
        fontSize,
      }}
      title={[firstName, lastName].filter(Boolean).join(' ') || ''}
    >
      {getInitials(firstName, lastName)}
    </div>
  );
};

export default InitialsAvatar;
